export type ReactAddressCaptureProps = {
  id?: string
  theme?: string
  response?: string
  messages?: string
  configuredFor?: ServiceabilityType
  isInEditor?: boolean
  tokenProperties?: string
  locationPin?: string
  simplifiedIcon?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  multipleAddressChevron?: string
  multipleAddressChevronAlt?: string
  inLayoutContainer?: boolean
  lob?: string
  hideMCP?: boolean
  isOutageMap?: boolean
}

export enum ServiceabilityType {
  ADDRESSSERVICEABILITY = 'resi-prospect',
  MOVETRANSFER = 'move-transfer',
  OUTAGEMAP = 'outagemap'
}
